<template>
    <div class="app_container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="五彩嘉兴申报" name="one">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无申报信息</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="基层干部主题培训" name="two">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无培训信息</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="考核评价" name="three">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无考核评价信息</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="学习用书征订" name="four">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无信息</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="其他" name="five">
                <div class="empty">
                    <img class="empty-image" src="../../../assets/image/jiaxing/empty.png" alt />
                    <div class="empty-text">暂无其他信息</div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        activeName: 'one'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>
    .empty {
        display: flex;
        flex-direction: column;
        padding-top: 100px;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .empty-image {
        width: 240px;
        height: 240px;
        margin-bottom: 20px;
    }
    .empty-text {
        color: #999999;
        font-size: 16px;
    }

</style>
